const reloadPromptLocale = {
  reloadPrompt: {
    message: "Une nouvelle version de l'application est disponible.",
    refresh: "Mettre à jour",
    dismiss: {
      label: "Plus tard",
      header: "Mise à jour automatique",
      message:
        "L'application se mettra à jour automatiquement demain à {hour}. Voulez-vous toujours reporter la mise à jour ?",
      acceptLabel: "Oui, reporter",
      rejectLabel: "Non, mettre à jour maintenant",
    },
    popover: {
      title: "Mise à jour disponible",
      updateAvailable: "Mise à jour disponible",
      currentVersion: "Version actuelle",
      newVersion: "Nouvelle version",
      autoUpdateMessage: "L'application se mettra à jour automatiquement demain à {hour}.",
      cancel: "Annuler",
      updateNow: "Mettre à jour",
    },
  },
};

export type ReloadPromptLocale = typeof reloadPromptLocale;
export default reloadPromptLocale;
